export enum NoBookingScheduleReason {
    NO_TIME = 'NO_TIME',
    LATER_DATE = 'LATER_DATE',
    MEET_SOONER = 'MEET_SOONER',
}

export interface BookFurtherOutOption {
    title: string;
    detailReason: NoBookingScheduleReason;
}

export const BOOK_FURTHER_OUT_OPTIONS: BookFurtherOutOption[] = [
    {
        title: "I couldn't find a time that worked",
        detailReason: NoBookingScheduleReason.NO_TIME,
    },
    {
        title: "The Guide I want doesn't have a time",
        detailReason: NoBookingScheduleReason.MEET_SOONER,
    },
    {
        title: 'I need to book a later date',
        detailReason: NoBookingScheduleReason.LATER_DATE,
    },
] as const;
